<template>
  <Dialog :commonDialog="documentDialog">
    <template v-slot:title> Upload Document</template>
    <template v-slot:body>
      <v-form
        ref="documentForm"
        v-model.trim="export_valid"
        lazy-validation
        v-on:submit.stop.prevent="documentValidated()"
      >
        <table class="table-document" width="100%">
          <template v-for="(file, index) in files">
            <tr
              :key="`file-row-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td colspan="2" class="px-2">
                <div class="mb-3">
                  <label for="file" class="font-weight-600 required">
                    Upload File
                  </label>
                  <v-file-input
                    hide-details
                    class="px-0"
                    dense
                    filled
                    solo
                    flat
                    v-model="file.file"
                    placeholder="Select File"
                    prepend-icon=""
                    prepend-inner-icon="$file"
                    v-on:change="updateFile(index, $event)"
                    v-on:click:clear="updateFile(index, $event)"
                    color="cyan"
                    :rules="[fileSizeRule, (file) => fileTypeRule(file, index)]"
                  />
                </div>
                <div class="mb-1">
                  <label for="name" class="font-weight-600 required">
                    File Name</label
                  >
                  <TextField
                    id="name"
                    dense
                    filled
                    placeholder="File Name"
                    solo
                    flat
                    counter="50"
                    v-model="file.name"
                    color="cyan"
                    :maxlength="250"
                    :rules="[validateRules.required(file.name, 'Name')]"
                  />
                </div>
                <v-checkbox
                  v-if="showAppendToPdf"
                  v-model="file.append_to_pdf"
                  :disabled="!isImageFile(file)"
                  color="cyan"
                  dense
                  hide-details
                  label="Append to invoice PDF"
                ></v-checkbox>
              </td>
              <td
                v-if="false"
                width="10%"
                align="center"
                valign="middle"
                class="px-2"
                :rowspan="extensive ? 4 : 1"
              >
                <v-btn
                  v-on:click="removeFile(index)"
                  color="red lighten-1 white--text"
                  class=""
                  icon
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr
              :key="`file-meta-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td class="px-2">
                <div class="mb-1">
                  <label for="document-no" class="font-weight-600 required">
                    Document NO</label
                  >
                  <TextField
                    id="document-no"
                    dense
                    filled
                    placeholder="Document No"
                    solo
                    flat
                    v-model="file.document_no"
                    color="cyan"
                    :maxlength="50"
                    :rules="[
                      validateRules.required(file.document_no, 'Document No'),
                    ]"
                  />
                </div>
              </td>
              <td class="px-2">
                <div class="mb-1">
                  <label for="document-type" class="font-weight-600 required">
                    Document Type</label
                  >
                  <v-select
                    id="document-type"
                    dense
                    filled
                    solo
                    flat
                    :items="documentTypeOptions"
                    v-model="file.document_type"
                    color="cyan"
                    placeholder="Select Document Type"
                    :rules="[
                      validateRules.required(
                        file.document_type,
                        'Document Type'
                      ),
                    ]"
                    @change="handleDocumentTypeChange(file)"
                  />
                </div>
              </td>
            </tr>
            <tr
              v-if="file.document_type === 'Others'"
              :key="`file-document-type-other-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td colspan="2" class="px-2">
                <div class="mb-1">
                  <label
                    for="document-type-other"
                    class="font-weight-600 required"
                  >
                    Specify Document Type</label
                  >
                  <TextField
                    id="document-type-other"
                    dense
                    filled
                    placeholder="Enter document type"
                    solo
                    flat
                    v-model="file.document_type_other"
                    color="cyan"
                    :maxlength="250"
                    :rules="[documentTypeOtherRule(file)]"
                  />
                </div>
              </td>
            </tr>
            <tr
              v-if="!extensive"
              :key="`file-date-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td class="px-2">
                <div>
                  <label for="file" class="font-weight-600"> Start Date</label>
                  <DatePicker
                    solo
                    :nullable="true"
                    placeholder="Start Date"
                    id="export-from-date"
                    v-model="file.start_date"
                    :min-date="currentDate"
                    @input="handleStartDateChange(file)"
                  ></DatePicker>
                </div>
              </td>
              <td class="px-2">
                <div>
                  <label for="file" class="font-weight-600"> End Date</label>
                  <DatePicker
                    solo
                    :nullable="true"
                    placeholder="End Date"
                    :pageLoading="pageLoading"
                    v-model="file.end_date"
                    :min-date="file.start_date"
                    :disabled="!file.start_date"
                    @input="handleEndDateChange(file)"
                  ></DatePicker>
                </div>
              </td>
            </tr>
            <tr
              v-if="!extensive"
              :key="`file-reminder-date-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td colspan="2" class="px-2">
                <div>
                  <label for="file" class="font-weight-600">
                    Reminder Date</label
                  >
                  <DatePicker
                    solo
                    placeholder="Reminder Date"
                    id="export-from-date"
                    :nullable="true"
                    v-model="file.reminder_date"
                    :min-date="file.start_date"
                    :max-date="file.end_date"
                    :disabled="!file.start_date || !file.end_date"
                  ></DatePicker>
                </div>
              </td>
            </tr>
            <tr
              v-if="!extensive || documentType == 24"
              :key="`file-tag-${index}`"
              :class="{ 'table-alternate-row': index % 2 }"
            >
              <td colspan="2" class="px-2">
                <div>
                  <label for="file" class="font-weight-600"> Tags </label>
                  <TagAutoComplete
                    type="text"
                    v-model="file.tags"
                    :document-tag-type="documentType"
                    :tag-type="getDocumentTagModuleType()"
                  />
                </div>
              </td>
            </tr>
          </template>
        </table>
        <!-- <v-btn
          color="cyan white--text"
          class="mt-2 ml-4"
          tile
          depressed
          v-on:click="addMore()"
        >
          <v-icon>mdi-plus</v-icon> Add More...
        </v-btn> -->
      </v-form>
      <div class="px-4">
        <AttachFile
          v-if="false"
          @update:file="addMoreFile"
          :validFileTypes="fileTypes"
          :max-limit="maxLimit"
          :total-files="files.length"
        ></AttachFile>
        <v-form
          v-if="false"
          ref="documentForm"
          v-model.trim="export_valid"
          lazy-validation
          v-on:submit.stop.prevent="documentValidated()"
        >
          <FileUpload v-model="files" :maxLimit="maxLimit"> </FileUpload>
        </v-form>
      </div>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        tile
        :disabled="attachLoading"
        :loading="attachLoading"
        v-on:click="$emit('close', true)"
      >
        Close
      </v-btn>
      <v-btn
        :disabled="!export_valid || attachLoading"
        :loading="attachLoading"
        class="white--text"
        depressed
        color="cyan"
        tile
        v-on:click="documentValidated()"
      >
        Submit
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ApiService from "@/core/services/api.service";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import MomentJS from "moment-timezone";
import ValidationMixin from "@/core/plugins/validation-mixin";
import FileUpload from "@/view/components/app-component/FileInput.vue";
import AttachFile from "@/view/components/AttachFile";
//import { SET_ERROR } from "@/core/services/store/common.module";
import TagAutoComplete from "@/view/pages/partials/TagAutoCompleteInput";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
export default {
  mixins: [ValidationMixin],
  name: "export-dialog",
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      fileIds: [],
      export_valid: true,
      attachLoading: false,
      /*  prefile:[], */
      files: [
        {
          file: null,
          name: null,
          remark: null,
          suffix: null,
          tags: [],
          document_no: null,
          document_type: null,
          document_type_other: null,
          start_date: null,
          end_date: null,
          reminder_date: null,
          append_to_pdf: false,
        },
      ],
      documentTypeOptions: [
        "PO",
        "Support Document",
        "Completion",
        "Signback",
        "Others",
      ],
      customer: null,
      currentDate: MomentJS().format("YYYY-MM-DD"),
      search: null,
      items: [],
      pageLoading: false,
    };
  },
  props: {
    tagType: {
      type: String,
      default: null,
    },
    moduleType: {
      type: String,
      default: null,
    },
    documentDialog: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    documentType: {
      type: Number,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    documentId: {
      type: Number,
      default: null,
    },
    parentType: {
      type: String,
      default: null,
    },
    parentTypeId: {
      type: Number,
      default: null,
    },
    maxLimit: {
      type: Number,
      default: 5,
    },
    fileTypes: {
      type: Array,
      default: () => {
        return [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "pdf",
          "docx",
          "doc",
          "xls",
          "xlsx",
        ];
      },
    },
    extensive: {
      type: Boolean,
      default: false,
    },
    uploadImmediately: {
      type: Boolean,
      default: true,
    },
    showAppendToPdf: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    documentDialog(param) {
      this.files = [];
      if (param) {
        this.customer = null;
        this.files = [
          {
            file: null,
            name: null,
            remark: null,
            suffix: null,
            tags: [],
            document_no: null,
            document_type: null,
            document_type_other: null,
            base64: null,
            start_date: null,
            end_date: null,
            reminder_date: null,
            append_to_pdf: false,
          },
        ];
      }
    },
  },
  methods: {
    fileSizeRule(file) {
      if (!file) return true;

      const maxSize = 5 * 1024 * 1024;

      let isInvalid = false;

      if (Array.isArray(file)) {
        isInvalid = file.some((f) => f.size > maxSize);
      } else {
        isInvalid = file.size > maxSize;
      }

      if (isInvalid) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Filee size must be less than 5 MB.")
        );

        return " ";
      }

      return true;
    },
    fileTypeRule(file) {
      if (!file) return true;

      const fileType = file.name.split(".").pop().toLowerCase();
      const validTypes = this.fileTypes.map((type) => type.toLowerCase());

      if (!validTypes.includes(fileType)) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            `Only ${this.fileTypes
              .join(", ")
              .toUpperCase()} file types are allowed.`
          )
        );
        return " ";
      }

      return true;
    },
    manageLimit(e, index) {
      if (this.files[index].remark && this.files[index].remark.length > 199) {
        e.preventDefault();
      }
    },
    onPaste(e, index) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.files[index].remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.files[index].remark = trimValue;
        e.preventDefault();
      }
    },

    addMore() {
      this.files.push({
        file: null,
        name: null,
        remark: null,
        suffix: null,
        tags: [],
        document_no: null,
        document_type: null,
        document_type_other: null,
        start_date: null,
        end_date: null,
        reminder_date: null,
        append_to_pdf: false,
      });
    },

    documentValidated() {
      if (!this.$refs.documentForm.validate()) {
        return false;
      }

      if (!this.uploadImmediately) {
        this.$emit("success", this.files);
        this.$emit("close", true);
        return;
      }

      this.submitDocument();
    },
    handleStartDateChange(file) {
      if (
        file.end_date &&
        new Date(file.end_date) < new Date(file.start_date)
      ) {
        file.end_date = null;
      }

      if (
        file.reminder_date &&
        new Date(file.reminder_date) < new Date(file.start_date)
      ) {
        file.reminder_date = null;
      }
    },
    handleDocumentTypeChange(file) {
      if (file.document_type !== "Others") {
        file.document_type_other = null;
      }
    },
    documentTypeOtherRule(file) {
      return (value) => {
        if (file.document_type === "Others") {
          return !!value || "Specify Document Type is required.";
        }
        return true;
      };
    },

    handleEndDateChange(file) {
      if (
        file.start_date &&
        new Date(file.end_date) < new Date(file.start_date)
      ) {
        file.end_date = null;
      }

      if (
        file.reminder_date &&
        new Date(file.reminder_date) > new Date(file.end_date)
      ) {
        file.reminder_date = null;
      }
    },
    submitDocument() {
      console.log("submitting document to server");
      const _this = this;
      const params = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].file && this.files[i].name) {
          params.append(`file[${i}][file]`, this.files[i].file);
          params.append(`file[${i}][name]`, this.files[i].name);
          if (this.showAppendToPdf && this.isImageFile(this.files[i])) {
            params.append(
              `file[${i}][append_to_pdf]`,
              this.files[i].append_to_pdf ? "1" : "0"
            );
          }
          if (this.files[i].document_no) {
            params.append(`file[${i}][document_no]`, this.files[i].document_no);
          }
          if (this.files[i].document_type) {
            params.append(
              `file[${i}][document_type]`,
              this.files[i].document_type
            );
          }
          if (this.files[i].document_type_other) {
            params.append(
              `file[${i}][document_type_other]`,
              this.files[i].document_type_other
            );
          }
          if (this.files[i].remark) {
            params.append(`file[${i}][remark]`, this.files[i].remark);
          }

          if (this.files[i].start_date) {
            params.append(`file[${i}][start_date]`, this.files[i].start_date);
          }
          if (this.files[i].end_date) {
            params.append(`file[${i}][end_date]`, this.files[i].end_date);
          }
          if (this.files[i].reminder_date) {
            params.append(
              `file[${i}][reminder_date]`,
              this.files[i].reminder_date
            );
          }
          if (this.files[i]?.tags) {
            for (let j = 0; j < this.files[i]?.tags?.length; j++) {
              params.append(
                `file[${i}][tags][${j}][text]`,
                this.lodash.toString(this.files[i].tags[j].text)
              );
              params.append(
                `file[${i}][tags][${j}][color]`,
                this.lodash.toString(this.files[i].tags[j].color)
              );
            }
          }
        }
      }

      params.append("type_id", this.documentId !== null ? this.documentId : 0);
      params.append("type", this.documentType);
      params.append("module_type", this.getDocumentTagModuleType());

      if (this.parentType && this.parentTypeId && this.parentTypeId > 0) {
        params.append("parent_type", this.parentType);
        params.append("parent_type_id", this.parentTypeId);
      }

      this.attachLoading = true;

      ApiService.setHeader();
      ApiService.upload("all-documents", params)
        .then((data) => {
          const uploadedFiles =
            data && data.data && data.data.data ? data.data.data : [];
          this.fileIds = uploadedFiles;
          _this.$emit("getUploadedIds", this.fileIds);
          _this.$emit("success", this.fileIds);
          _this.$emit("close", true);
        })
        .catch((error) => {
          this.$emit("error", error);
          this.logError(error);
        })
        .finally(() => {
          this.attachLoading = false;
        });
    },
    updateFile(index, file) {
      this.files[index].append_to_pdf = false;
      if (file && file.name) {
        this.files[index].name = file.name.split(".").slice(0, -1).join(".");
        this.files[index].suffix = `${file.name.split(".").pop()}`;
      } else {
        this.files[index].name = null;
        this.files[index].suffix = null;
      }
    },
    isImageFile(file) {
      const mimeType = String(file?.file?.type || "").toLowerCase();
      const extension = String(file?.suffix || "").toLowerCase();
      return (
        mimeType.startsWith("image/") ||
        ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)
      );
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    getDocumentTagModuleType() {
      if (this.moduleType) {
        return this.moduleType;
      }

      if (this.tagType) {
        return this.tagType;
      }

      const moduleTypes = {
        1: "customer",
        2: "quotation",
        3: "invoice",
        9: "goods",
        10: "service",
        18: "purchase-order",
        20: "lead",
        21: "opportunity",
        22: "contract",
        24: "leave",
        28: "user",
        29: "engineer",
        34: "claim",
        37: "tool",
        51: "enquiry",
        55: "error-code",
        56: "preventive-maintanance",
        59: "adjustment",
        78: "asset",
        80: "parts",
        115: "warranty",
        302: "visit",
      };

      return moduleTypes[this.documentType] || null;
    },
    getTags() {
      const _this = this;
      ApiService.setHeader();
      ApiService.get("setting/all-tags").then((res) => {
        _this.items = res.data && res.data.data ? res.data.data : [];
      });
    },
    filterTag(item, queryText, itemText) {
      if (item.header) return false;
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
  },
  components: {
    // SET_ERROR,
    Dialog,
    DatePicker,
    AttachFile,
    FileUpload,
    TagAutoComplete,
  },
  mounted() {
    console.log("DocumentwithName uploadImmediately =", this.uploadImmediately);
    this.getTags();
  },
  computed: {
    ...mapGetters(["errors", "localDB"]),
  },
};
</script>
<style scoped>
.removeShadow > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  padding: 0;
}
.v-application .py-3 {
  padding-bottom: 0px !important;
}
.text-right.col-md-12.col {
  margin: -10px;
}
</style>
